import { observer } from 'mobx-react-lite'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { type IIconsVector } from 'shared/ui/Icon'
import { getAriaLabel } from 'shared/lib'
import { type RegistrationAuthoritySelectStore } from './store/RegistrationAuthoritySelectStore'
import styles from './styles.module.scss'

type IRegistrationAuthoritySelectProps = {
  store: RegistrationAuthoritySelectStore
  onCountryChange?: () => void
}

export const RegistrationAuthoritySelect = observer(
  ({ store, onCountryChange }: IRegistrationAuthoritySelectProps) => {
    const { countries, country, countryData, setCountry } = store

    return (
      <SelectField
        labelText='Registration authority'
        value={country}
        items={countries}
        setValue={(country) => {
          setCountry(country)
          onCountryChange?.()
        }}
        className={styles.countrySelect}
        selectProps={{
          dropdownProps: {
            width: 492,
            margin: -40,
            withSearch: false,
            withTextInput: false,
            ariaLabel: getAriaLabel('Registration authority'),
          },
        }}
        btnProps={{
          size: 'medium',
          className: styles.textField,
          text: countryData ? countryData.name : 'Select',
          textIcon: countryData ? (countryData.flag as IIconsVector) : undefined,
          textIconColor: countryData?.iconColor,
        }}
      />
    )
  }
)
